const dayjs = require('dayjs')

const {
  findRangeForDate
} = require('./../../server/routers/utils/elastic/offerQueries.js')

export const getCampaignRange = day => {
  const today = day ?? dayjs().format('YYYY-MM-DD')
  const startVisibileDateRange = findRangeForDate(today)
  return startVisibileDateRange
}
